// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.plan.EncounterUpdateCarePlanItemRecallRequest */
/* istanbul ignore next */
@GandalfModel
export class EncounterUpdateCarePlanItemRecallRequest extends GandalfModelBase {

	@GandalfLabel('Recall Care Plan Item')
	@GandalfValidator({ notNull: { message: 'Recall Care Plan Item is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	carePlanItemRecallId!: number;

	@GandalfLabel('Location')
	@GandalfProperty({ designType: Number })
	locationId!: number | null;

}
